import React, { FC } from 'react';

import { useUserAgent } from 'app/lib/user-agent';

import { DesktopLayout } from './components/DesktopLayout';
import { MobileLayout } from './components/MobileLayout';

export const Download: FC = () => {
  const { mobileOperationSystem, isMobile } = useUserAgent();

  return (
    <>
      {!isMobile && (
        <DesktopLayout />
      )}
      {isMobile && (
        <MobileLayout os={mobileOperationSystem} />
      )}
    </>
  );
};
